module.exports = __webpack_public_path__ + "static/media/phone-icon.d3602d17.svg";